export const API_BASE_URL = 'https://api.crackeddevs.com/api';
export const API_KEY = '824c4054-c501-460f-b12c-411079a20aab';